import { Icon } from '@iconify/react'
import { formatArea, formatRelative, freshnessOf } from '../utils/events'

const EventList = ({ events, selectedId, onSelect }) => {
    if (events.length === 0) {
        return (
            <div className="empty">
                <Icon icon="mdi:fire-off" aria-hidden="true" />
                <p>Aucun feu ne correspond aux filtres.</p>
            </div>
        )
    }

    return (
        <ul className="event-list">
            {events.map(ev => (
                <li key={ev.id}>
                    <button
                        type="button"
                        className={`event-item${ev.id === selectedId ? ' is-selected' : ''}`}
                        onClick={() => onSelect(ev.id)}
                        aria-current={ev.id === selectedId}
                    >
                        <span className={`event-item__dot freshness--${freshnessOf(ev.timestamp)}`} aria-hidden="true" />
                        <span className="event-item__body">
                            <span className="event-item__title">{ev.title}</span>
                            <span className="event-item__meta">
                                {ev.regionLabel} · {formatRelative(ev.timestamp)}
                            </span>
                        </span>
                        <span className="event-item__area">{formatArea(ev.hectares)}</span>
                    </button>
                </li>
            ))}
        </ul>
    )
}

export default EventList
